import { FeaturedTutorial } from '.';

interface TutorialData {
  [key: string]: {
    tutorialsLink: string;
    featuredTutorials: FeaturedTutorial[];
  };
}

export const TUTORIALS_DATA: TutorialData = {
  docker: {
    tutorialsLink:
      'https://www.digitalocean.com/community/tags/docker?subtype=tutorial',
    featuredTutorials: [
      {
        title: 'How To Remove Docker Images, Containers, and Volumes',
        link: 'https://www.digitalocean.com/community/tutorials/how-to-remove-docker-images-containers-and-volumes'
      },
      {
        title: 'How To Bootstrap a New Laravel Application with Docker Compose',
        link: 'https://www.digitalocean.com/community/tutorials/how-to-bootstrap-a-new-laravel-application-with-docker-compose'
      },
      {
        title:
          'Containerizing a Ruby on Rails Application for Development with Docker Compose',
        link: 'https://www.digitalocean.com/community/tutorials/containerizing-a-ruby-on-rails-application-for-development-with-docker-compose'
      }
    ]
  },
  wordpress: {
    tutorialsLink:
      'https://www.digitalocean.com/community/tags/wordpress?subtype=tutorial',
    featuredTutorials: [
      {
        title: 'How to Optimize WordPress on Ubuntu',
        link: 'https://www.digitalocean.com/community/tutorials/how-to-optimize-wordpress-on-ubuntu-20-04'
      },
      {
        title: 'How to Install WordPress with LEMP on Ubuntu',
        link: 'https://www.digitalocean.com/community/tutorials/how-to-install-wordpress-with-lemp-on-ubuntu-20-04'
      },
      {
        title: 'How To Install WordPress on Ubuntu with a LAMP Stack',
        link: 'https://www.digitalocean.com/community/tutorials/how-to-install-wordpress-on-ubuntu-20-04-with-a-lamp-stack'
      }
    ]
  },
  lamp: {
    tutorialsLink:
      'https://www.digitalocean.com/community/tags/lamp-stack?subtype=tutorial',
    featuredTutorials: [
      {
        title:
          'How To Install Linux, Apache, MySQL, PHP (LAMP) stack on Ubuntu',
        link: 'https://www.digitalocean.com/community/tutorials/how-to-install-linux-apache-mysql-php-lamp-stack-on-ubuntu-20-04'
      }
    ]
  },
  lemp: {
    tutorialsLink:
      'https://www.digitalocean.com/community/tags/lemp?subtype=tutorial',
    featuredTutorials: []
  },
  nodejs: {
    tutorialsLink:
      'https://www.digitalocean.com/community/tags/node-js?subtype=tutorial',
    featuredTutorials: [
      {
        title: 'How To Write and Run Your First Program in Node.js',
        link: 'https://www.digitalocean.com/community/tutorials/how-to-write-and-run-your-first-program-in-node-js'
      },
      {
        title: 'How To Create a Node.js Module',
        link: 'https://www.digitalocean.com/community/tutorials/how-to-create-a-node-js-module'
      },
      {
        title: 'How To Install Node.js on Ubuntu',
        link: 'https://www.digitalocean.com/community/tutorials/how-to-install-node-js-on-ubuntu-18-04'
      }
    ]
  },
  mongodb: {
    tutorialsLink:
      'https://www.digitalocean.com/community/tags/mongodb?subtype=tutorial',
    featuredTutorials: [
      {
        title:
          'How To Back Up, Restore, and Migrate a MongoDB Database on Ubuntu',
        link: 'https://www.digitalocean.com/community/tutorials/how-to-back-up-restore-and-migrate-a-mongodb-database-on-ubuntu-20-04'
      },
      {
        title: 'How To Import and Export a MongoDB Database on Ubuntu',
        link: 'https://www.digitalocean.com/community/tutorials/how-to-import-and-export-a-mongodb-database-on-ubuntu-20-04'
      }
    ]
  },
  django: {
    tutorialsLink:
      'https://www.digitalocean.com/community/tags/django?subtype=tutorial',
    featuredTutorials: [
      {
        title: 'How To Create a URL Shortener with Django and GraphQL',
        link: 'https://www.digitalocean.com/community/tutorials/how-to-create-a-url-shortener-with-django-and-graphql'
      },
      {
        title: 'How To Add Unit Testing to Your Django Project',
        link: 'https://www.digitalocean.com/community/tutorials/how-to-add-unit-testing-to-your-django-project'
      },
      {
        title:
          'How To Install Django and Set Up a Development Environment on Ubuntu',
        link: 'https://www.digitalocean.com/community/tutorials/how-to-install-django-and-set-up-a-development-environment-on-ubuntu-20-04'
      }
    ]
  },
  dokku: {
    tutorialsLink:
      'https://www.digitalocean.com/community/tags/dokku?subtype=tutorial',
    featuredTutorials: []
  },
  mysql: {
    tutorialsLink:
      'https://www.digitalocean.com/community/tags/mysql?subtype=tutorial',
    featuredTutorials: [
      {
        title: 'How To Install MySQL on Ubuntu',
        link: 'https://www.digitalocean.com/community/tutorials/how-to-install-mysql-on-ubuntu-18-04'
      },
      {
        title:
          'SQLite vs MySQL vs PostgreSQL: A Comparison Of Relational Database Management Systems',
        link: 'https://www.digitalocean.com/community/tutorials/sqlite-vs-mysql-vs-postgresql-a-comparison-of-relational-database-management-systems'
      },
      {
        title: 'How To Reset Your MySQL or MariaDB Root Password on Ubuntu',
        link: 'https://www.digitalocean.com/community/tutorials/how-to-reset-your-mysql-or-mariadb-root-password-on-ubuntu-20-04'
      }
    ]
  },
  'ruby-on-rails': {
    tutorialsLink:
      'https://www.digitalocean.com/community/tags/ruby-on-rails?subtype=tutorial',
    featuredTutorials: [
      {
        title: 'How To Install Ruby on Rails with rbenv on Ubuntu',
        link: 'https://www.digitalocean.com/community/tutorials/how-to-install-ruby-on-rails-with-rbenv-on-ubuntu-18-04'
      },
      {
        title: 'How To Set Up a Ruby on Rails Project with a React Frontend',
        link: 'https://www.digitalocean.com/community/tutorials/how-to-set-up-a-ruby-on-rails-project-with-a-react-frontend'
      },
      {
        title:
          'Containerizing a Ruby on Rails Application for Development with Docker Compose',
        link: 'https://www.digitalocean.com/community/tutorials/containerizing-a-ruby-on-rails-application-for-development-with-docker-compose'
      }
    ]
  }
};
